export default __webpack_public_path__ + "static/media/19.5954cbf7.png";